module.exports = __webpack_public_path__ + "img/bg-frame-ja.73667eb6.png";